<template>
  <div class="Root">
    <div @click="openCertPage('ProductManagerCert/')" class="menuButton">
      <img style="width: 60px;height: 60px;" src="../../assets/img/certificate.png" />
      <span style="margin-left:20px">证书</span>
    </div>
    <div @click="openCertPage('ProductManagerManual/')" class="menuButton">
      <img style="width: 60px;height: 60px;" src="../../assets/img/manual.png" />
      <span style="margin-left:20px">技术手册</span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openCertPage(dirname) {
      this.$router.push({
        path: 'CertView', query:
        {
          catlog: dirname
        }
      })
    }
  },
  mounted() {
    this.$router.push({
      path: 'CertView', query:
      {
        catlog: '/'
      }
    })
  }
};
</script>

<style soped>
.menuButton {
  width: 260px;
  height: 90px;
  background: #345ACC;
  border-radius: 20px;
  line-height: 90px;
  cursor: pointer;
  display: inline-block;
  font-size: 19px;
  text-align: center;
  margin-left: 180px;
  font-weight: 400;
  color: #fff;

}

.menuButton:hover {
  width: 260px;
  height: 90px;
  background: #7192F4;
  border-radius: 20px;
  color: #FFF;
}

.menuButton:active {
  background-color: #2060a8;
}


.Root {
  vertical-align: middle;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 1500px;
  height: 100px;
  margin-left: -800px;
  margin-top: -50px;
}
</style>